import { useQuery } from '@tanstack/react-query';
import { getContentDetail } from '../services/requests';

export const useContentDetail = (id: string) => {
  return useQuery({
    queryKey: ['contentDetail', id],
    queryFn: () => getContentDetail(id),
    enabled: !!id && id !== 'create',
  });
};
